module.exports = __webpack_public_path__ + "media/images/coauthors-docs-296d0f1687219509bc05f611a980e07d.png";